import { devtoolsApi } from '#/dev/devtools';
import { useConfig } from '#/hooks/useConfig';
import { defaultConfig } from '#/service/config/defaultConfig';
import { useTranslationStore } from '#/store/translation/translation.store';

export const useMenu = () => {
  const { translatedMenu } = useTranslationStore();
  const { menu: menuFromConfig } = useConfig();
  // If `translatedMenu` is defined it means that other language was selected and as such it takes precedence.
  // Otherwise default `menu` config is used, which contains a default english translations
  const menu = translatedMenu ?? menuFromConfig ?? defaultConfig.menu;

  if (process.env.goal === 'local') {
    devtoolsApi.setContexts({ menu });
  }

  return menu;
};
